import { prop } from 'ramda';

// eslint-disable-next-line import/prefer-default-export
export const callMeBackSelector = prop('callMeBack');
